
/**
* Effettua la validazione del form di registrazione in base alla lingua.
* @param {any} lcid
* @returns {boolean}
*/
function RegisterUser(lcid, idsito) {
    waiting.Show();

    try {
        var formstate = true;
        var scroll = true;
        var usertype = parseInt($('#reg-tipologiacliente').val());
        var p1 = $('#regsrv1').prop('checked');

        if (!$('#cbshippingsameaddress')[0].checked) {
            copyaddress(true, lcid);
        }

        $('form#fregistrazione :input').each(function (index, value) {
            $(this).removeClass('is-invalid');
            if (!$(this)[0].closest('#panel-spedizione') || ($(this)[0].closest('#panel-spedizione') && $('#cbshippingsameaddress')[0].checked)) {
                if ($(this).attr('required') && ($(this)[0].disabled == false || !$(this).attr('disabled'))) {
                    if (!$(this).val()?.trim()) {
                        $(this).addClass('is-invalid');
                        formstate = false;
                    }
                }
            }
            else {
                $(this).removeClass('is-invalid');
            }
        });

        if (CheckPassword($('#reg-password'), $('#reg-cpassword'), $('#chkpassword'), idsito) == false) {
            formstate = false;
        }

        if ($('#dbDataNascita').length > 0) {
            if ($('#dbDataNascita').dxDateBox('instance').option('value') == null) {
                $('#dbDataNascita').dxDateBox('instance').option({
                    validationStatus: 'invalid',
                    validationErrors: [{ message: mainController.GetLabel('lErroreDataNonIndicata') }]
                });
            }
        }

        /* Controllo partita IVA */
        var piva = $('#reg-piva');
        var GruppoIva = $('#reg-isGruppoIva');
        var cf = $('#reg-cf');
        if (piva.length > 0) {

            if (piva && piva.val()) {
                piva.val(piva.val()?.replaceAll(' ', ''));
            }

            if (piva) {
                if (piva.attr('required') || (!piva.attr('required') && piva.val())) {
                    switch (lcid) {
                        case 1040:
                            if ((GruppoIva.length > 0 && GruppoIva.val() == 'False') || GruppoIva.length == 0) {
                                if (CheckPartitaIvaReg(piva.val(), cf.val(), GruppoIva?.val()) == false) {
                                    $('#chkcf').removeClass('hidden');
                                    formstate = false;
                                }
                                else {
                                    $('#chkcf').addClass('hidden');
                                    $('#chkpiva').addClass('hidden');
                                }
                            }
                            /* Controllo partita GRUPPO IVA */
                            else {

                                if (mainController.CheckPartitaIva(piva.val()).length == 0 && mainController.CheckPartitaIva(cf.val()).length > 0) {
                                    cf.addClass('is-invalid');
                                    $('#chkpiva').addClass('hidden');

                                    $('#chkcf').removeClass('hidden');
                                    $('#chkcf').html(mainController.GetLabel('lErrorePIVANonValido'));
                                    formstate = false;
                                }
                                else if (mainController.CheckPartitaIva(piva.val()).length > 0 && mainController.CheckPartitaIva(cf.val()).length == 0) {
                                    piva.addClass('is-invalid');
                                    $('#chkcf').addClass('hidden');

                                    $('#chkpiva').removeClass('hidden');
                                    $('#chkpiva').html(mainController.GetLabel('lErroreCFNonValido'));//lErroreCFNonValido
                                    formstate = false;
                                }
                                else if (mainController.CheckPartitaIva(piva.val()).length > 0 && mainController.CheckPartitaIva(cf.val()).length > 0) {
                                    piva.addClass('is-invalid');
                                    cf.addClass('is-invalid');
                                    $('#chkpiva').removeClass('hidden');
                                    $('#chkcf').removeClass('hidden');

                                    $('#chkpiva').html(mainController.GetLabel('lErrorePIVANonValido'));
                                    $('#chkcf').html(mainController.GetLabel('lErroreCFNonValido'));
                                    formstate = false;
                                }
                                else if (piva.val() == cf.val()) {
                                    piva.addClass('is-invalid');
                                    cf.addClass('is-invalid');
                                    $('#chkpiva').removeClass('hidden');

                                    $('#chkpiva').html(mainController.GetLabel('lErroreGruppoPivaUgualiCF'));
                                    formstate = false;
                                }
                                else if (CheckPartitaIvaReg(piva.val(), cf.val(), GruppoIva?.val()) == false) {
                                    formstate = false;
                                }
                                else {
                                    piva.removeClass('is-invalid');
                                    cf.removeClass('is-invalid');
                                    $('#chkpiva').addClass('hidden');
                                    $('#chkcf').addClass('hidden');
                                }
                            }

                            break;
                        case 1034:
                            if (ESDoc(piva.val()) == false) {
                                piva.addClass('is-invalid');
                                formstate = false;
                            }
                            break;
                        case 2070:
                            $('#reg-piva').removeClass('is-invalid');
                            $('#chkpiva').addClass('hidden');

                            if (/^(\d{9})$/.test(piva.val()) == false) {
                                piva.addClass('is-invalid');
                                $('#chkpiva').removeClass('hidden');
                                $('#chkpiva').html(mainController.GetLabel('lErrorePIVANonValido'));
                                formstate = false;
                            }
                            break;
                    }
                }
            }
            else {
                piva.addClass('is-invalid');
                formstate = false;
            }
        }

        /* Controllo email */
        if ($('#iduser').val() > 0 && $('#idtipocliente').val() == -1) {
            emailNonEsistente = true;
        }
        else if (!mainController.CheckEmail($('#reg-email').val())) {
            $('#reg-email').addClass('is-invalid');
            formstate = false;
        }


        /* Fatturazione Elettronica */
        var pFattEle = $('#panel-fattele');
        if (pFattEle.length > 0) {
            var pec = $('#reg-fpec');
            var sdi = $('#reg-fsdi');
            if (pFattEle.attr('required')) {
                if (!sdi.val() && !pec.val()) {
                    sdi.addClass('is-invalid');
                    pec.addClass('is-invalid');
                    $('#msgsdi').html(mainController.GetLabel('lErroreFattElettronica'));
                    $('#msgpec').html('');
                    formstate = false;
                }
                else {
                    if (sdi.val()) {
                        if (CheckSdi(sdi, usertype) == false) {
                            formstate = false;
                        }
                    }
                    if (pec.val()) {
                        if (mainController.CheckEmail(pec.val()) == false) {
                            pec.addClass('is-invalid');
                            $('#msgpec').html(mainController.GetLabel('lErrorePEC'));
                            formstate = false;
                        }
                        else {
                            pec.removeClass('is-invalid');
                            $('#msgpec').html('');
                        }
                    }
                }
            }
            else {
                if (sdi.val()) {
                    if (CheckSdi(sdi, usertype) == false) {
                        formstate = false;
                    }
                }
                if (pec.val()) {
                    if (mainController.CheckEmail(pec.val()) == false) {
                        pec.addClass('is-invalid');
                        $('#msgpec').html(mainController.GetLabel('lErrorePEC'));
                        formstate = false;
                    }
                    else {
                        pec.removeClass('is-invalid');
                        $('#msgpec').html('');
                    }
                }
            }
        }

        var titolo = $('#reg-titolo');
        if (titolo.length > 0) {
            if (!titolo.val() || titolo.val() == '0') {
                titolo.addClass('is-invalid');
                formstate = false;
            }
        }

        /* Controllo nazione */
        var fnazione = $('#reg-fnazione');
        if (!fnazione.val() || fnazione.val() == '0' || fnazione.val() == '') {
            fnazione.addClass('is-invalid');
            formstate = false;
        }
        if ($('#cbshippingsameaddress')[0].checked) {
            var snazione = $('#reg-snazione');
            if (!snazione.val() || snazione.val() == '0' || snazione.val() == '') {
                snazione.addClass('is-invalid');
                formstate = false;
            }
        }

        if (CheckCittaEProvincia(lcid, null) == false) {
            formstate = false;
        }

        /* Controllo Codice fiscale */
        var cf = $('#reg-cf');
        var cfCheck = $('#chkcf');
        if ((cf.prop('required') == true || cf.val()?.trim()?.length > 0 == true) && (((GruppoIva?.val() == 'True') == true && cf.hasClass('is-invalid') == false) || ((GruppoIva?.val() == 'True') == false))) {
            if (CheckCodiceFiscaleReg(usertype, cf.val().trim(), lcid, cfCheck) == false) {
                cf.addClass('is-invalid');
                formstate = false;
            }
            else {
                cf.removeClass('is-invalid');
            }
        }

        /* Controllo del CAP */
        if (CheckCapReg($('#reg-fcap'), lcid, $('#errorefcap')) == false) {
            formstate = false;
        }

        /* check recapito telefonico fatturazione */
        var ftel = $('#reg-ftelefono').val().trim();
        var fcel = $('#reg-fcellulare').val().trim();

        if (ftel === '' && fcel === '') {
            $('#reg-ftelefono').addClass('is-invalid');
            $('#reg-fcellulare').addClass('is-invalid');
            $('#chkfrecapito').html(mainController.GetLabel('lAvvisoRecapito'));
            formstate = false;
        }
        else {
            $('#reg-ftelefono').removeClass('is-invalid');
            $('#reg-fcellulare').removeClass('is-invalid');
        }

        /* check recapito telefonico spedizione */
        if ($('#cbshippingsameaddress')[0].checked) {
            var stel = $('#reg-stelefono').val().trim();
            var scel = $('#reg-scellulare').val().trim();
            if (stel === '' && scel === '') {
                $('#reg-stelefono').addClass('is-invalid');
                $('#reg-scellulare').addClass('is-invalid');
                $('#chkfrecapitos').html(mainController.GetLabel('lAvvisoRecapito'));
                formstate = false;
            }
            if (CheckCapReg($('#reg-scap'), lcid, $('#errorescap')) == false) {
                formstate = false;
            }
        }

        // Condizioni generali di vendita
        var cbcondizioni1 = $('#regsrv1')[0]; //accetto
        var cbcondizioni2 = $('#regsrv2')[0]; //non accetto
        if (cbcondizioni1 != null && cbcondizioni1 != undefined && cbcondizioni2 != null && cbcondizioni2 != undefined) {
            if (!cbcondizioni1.checked && !cbcondizioni2.checked) { // non ho scelto nulla
                $('#chkp1').html(mainController.GetLabel('lErroreCommerciale'));
                $('#lErroreSrv').addClass('is-invalid');
                scroll = false;
                formstate = false;
            }
            else if (!cbcondizioni1.checked && cbcondizioni2.checked) { // ho scelto di non accettare
                $('#chkp1').html(mainController.GetLabel('lErroreServizio'));
                $('#lErroreSrv').addClass('is-invalid');
                scroll = false;
                formstate = false;
            }
        }
        else {
            scroll = false;
            formstate = false;
        }

        // Privacy per marketing
        var cbmarketing1 = $('#regmktg1')[0];//accetto
        var cbmarketing2 = $('#regmktg2')[0];//non accetto
        if (cbmarketing1 != null && cbmarketing1 != undefined && cbmarketing2 != null && cbmarketing2 != undefined) {
            if (!cbmarketing1.checked && !cbmarketing2.checked) {
                $('#lErroreMktg').addClass('is-invalid');
                scroll = false;
                formstate = false;
            }
        }
        else {
            scroll = false;
            formstate = false;
        }

        // Privacy per profilazione
        var cbprofilazione1 = $('#regprof1')[0];//accetto
        var cbprofilazione2 = $('#regprof2')[0];//non accetto
        if (cbprofilazione1 != null && cbprofilazione1 != undefined && cbprofilazione2 != null && cbprofilazione2 != undefined) {
            if (!cbprofilazione1.checked && !cbprofilazione2.checked) {
                $('#lErroreProf').addClass('is-invalid');
                scroll = false;
                formstate = false;
            }
        }
        else {
            scroll = false;
            formstate = false;
        }

        /** check privacy */
        if (typeof p1 === 'undefined') {
            $('#regsrv1').addClass('is-invalid');
            $('#chkp1').html(mainController.GetLabel('lErroreCommerciale'));
            formstate = false;
        }
        //Controllo codice anaste
        var codiceanaste = $('#codiceanaste');

        if (codiceanaste.length > 0) {
            if (validitacodiceanaste != true) {
                $('#reg-codiceanaste').addClass('is-invalid');
                $('#errorecodiceanaste').removeClass('hidden');
                $('#errorecodiceanaste').html('Codice identificativo Anaste errato');
                formstate = false;
            }
        }

        if (formstate && emailNonEsistente == true) {
            if (typeof dataLayer !== 'undefined') {
                dataLayer.push({
                    'event': 'sign_up',
                    'method': 'registrazione',
                    'email': $('#reg-email').val()
                });
            }
            //waiting.Hide();
            return true;
        }
        else {
            if (emailNonEsistente == false) {
                $('#reg-email').addClass('is-invalid');
            }
            waiting.Hide();
            if (scroll) {
                $(window).scrollTop(0);
            }
            return false;
        }
    } catch (e) {
        waiting.Hide();
        $(window).scrollTop(0);
        console.log(e);
        return false;
    }
}

function VerificaCodiceAnaste() {
// gestito soltanto da anaste 
}
function VerificaPartitaIva(lcid) {
    try {
        if (lcid == 1040) {
            var labelPiva = $('#lb-piva');

            var labelCF = $('#lb-cf');
            var inputCF = $('#reg-cf');

            var chkcf = $('#chkcf');

            var iva = $('#reg-piva');
            var gruppoIva = $('#reg-isGruppoIva').val();
            var usertype = parseInt($('#reg-tipologiacliente').val());
            var p = {}
            p.Piva = iva.val();

            $('#chkpiva').html('');

            if (iva.val()?.trim()) {
                waitingBS.Show();

                $.ajax({
                    url: '/Account/VerificaPartitaIva',
                    type: 'POST',
                    data: p,
                    success: (result) => {
                        try {
                            if (result.esito == Costanti.ESITO_OK) {
                                $('#reg-piva').addClass('is-valid');
                                $('#reg-isGruppoIva').val('True');

                                $('#chkpiva').html(result.responseText);
                                $('#chkpiva').removeClass('hidden');
                                labelPiva.html(mainController.GetLabel('lPartitaIvaGruppo')).css('display', 'block');
                                labelCF.html(mainController.GetLabel('lPartitaIvaAppartenente')).css('display', 'block');
                                inputCF.removeClass('hidden');

                                waitingBS.Hide();
                            }
                            else {
                                $('#reg-isGruppoIva').val('False');
                                $('#chkpiva').addClass('hidden');

                                labelPiva.html(mainController.GetLabel('lPartitaIVA')).css('display', 'block');

                                inputCF.addClass('hidden');
                                inputCF.removeClass('is-invalid');

                                chkcf.addClass('hidden');
                                waitingBS.Hide();
                            }

                            CheckPartitaIvaReg(iva.val(), inputCF.val(), result.esito == Costanti.ESITO_OK);
                        }
                        catch (error) {
                            console.log(error);
                            waitingBS.Hide();
                        }
                    },
                    error: function (xhr, status, error) {
                        console.log(error);
                        console.log(status);
                        console.log(xhr);
                        mainController.NotifyMessage(mainController.GetLabel('lErroreGenerico'), Costanti.NOTIFY_COLOR_ERROR)
                        waitingBS.Hide();
                    }
                });
            }
        }
    }
    catch (error) {
        console.log(error);
        waitingBS.Hide();
    }
}


/**
 * Controlla la partita IVA italiana della registrazione
 * @param {string} piva La partita IVA
 * @param {string} cf Il codice fiscale nel caso di partita IVA
 * @param {boolean} gruppoIva Indica se è un gruppo IVA
 * @returns {boolean}
 */
function CheckPartitaIvaReg(piva, cf, gruppoIva) {
    try {

        if (typeof (gruppoIva) == 'string') {
            gruppoIva = gruppoIva?.toString().toLowerCase() == 'true';
        }

        var checkIva = mainController.CheckPartitaIva(piva.trim());
        if (checkIva.length > 0) {
            $('#reg-piva').addClass('is-invalid');
            $('#chkpiva').removeClass('hidden');
            $('#chkpiva').html(mainController.GetLabel(checkIva));
            return false;
        }

        if ($('#reg-piva').prop('disabled') != true) {
            var univoca = mainController.CheckUnivocitaPartitaIva(piva.trim(), cf.trim(), gruppoIva);

            if (univoca?.length > 0) {
                if (gruppoIva == true) {
                    $('#reg-cf').addClass('is-invalid');
                    $('#chkcf').removeClass('hidden');
                    $('#chkcf').html(mainController.GetLabel(univoca));
                }
                else {
                    $('#reg-piva').addClass('is-invalid');
                    $('#chkpiva').removeClass('hidden');
                    $('#chkpiva').html(mainController.GetLabel(univoca));
                }
                return false;
            }
        }

        $('#reg-cf').removeClass('is-invalid');

        $('#chkcf').addClass('hidden');
        $('#chkcf').removeClass('is-invalid');


        //$('#lb-cf').css('display', 'none');
        $('#reg-piva').removeClass('is-invalid');

        $('#chkpiva').addClass('hidden');
        $('#chkpiva').removeClass('is-invalid');

        return true;
    }
    catch (error) {
        console.log(error);
        return false;
    }
}

/**
 * Controlla il codice fiscale della registrazione
 * @param {number} usertype Il tipo di utente che si sta verificando
 * @param {string} cf Il codice fiscale
 * @param {number} lcid La lingua che sta verificando
 * @param {element} cfCheck Elemento che mostra l'errore del codice fiscale
 * @returns {boolean}
 */
function CheckCodiceFiscaleReg(usertype, cf, lcid, cfCheck) {
    try {
        var cfCheck = $("#chkcf");

        cfCheck.html('');

        cfCheck.addClass('hidden');
        if (lcid == 1040 && (usertype == 3 || usertype == 4 || usertype == 9 || (usertype == 2 && $('#reg-isGruppoIva').val() != undefined && $('#reg-isGruppoIva').val().toLowerCase() == 'true'))) { //onlus, P.A. e gruppo iva
            if (!/^[0-9]{11}$/.test(cf)) {
                cfCheck.removeClass('hidden');
                cfCheck.html(mainController.GetLabel('lErrorePIVANonValido'));
                return false;
            }
            else {
                return true;
            }
        }
        else if (lcid == 1036 && (usertype == 2 || usertype == 8)) { //Médicin e Hopitaux
            if (!/^[0-9]{14}$/.test(cf)) {
                return false;
            }
            else {
                return true;
            }
        }
        else if (mainController.CheckCodiceFiscale(cf) == false) {
            cfCheck.removeClass('hidden');
            cfCheck.html(mainController.GetLabel('lErrorePIVANonValido'));
            return false;
        }
        else {
            return true;
        }
    }
    catch (error) {
        console.log(error);
        return false;
    }
}